import palette from "../../../theme/palette";
import { LoadingBlock } from "./style";

const Loading = ({ color }) => {
  return (
    <LoadingBlock color={color || palette.textPrimary}>
      <div />
      <div />
      <div />
      <div />
    </LoadingBlock>
  );
};

export default Loading;
